<template>
  <div>
    <!-- <b-card>
      <div class="d-flex flex-column" style="max-height: 400px; overflow-y: scroll; overflow-x: hidden;">
        <div v-for="(key, index) in Object.keys(information)" :key="index" class="item row">
          <div class="col-4 label">{{ (key.charAt(0).toUpperCase() + key.substring(1)).split('_').join(' ') }} </div>
          <div class="col-1 separator">:</div>
          <div class="col-6 value">{{ information[key] }}</div>
        </div>
      </div>
    </b-card> -->
    <b-list-group class="informations">
      <!-- <b-list-group-item v-for="(key, index) in Object.keys(information)" :key="index" class="informations-item flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between informations-item-title">
          <h5 class="mb-2">{{ (key.charAt(0).toUpperCase() + key.substring(1)).split('_').join(' ') }}</h5>
        </div>
        <div>
          <p class="mb-0 informations-item-content">
            {{ information[key] }}
          </p>
        </div>
      </b-list-group-item> -->
      <b-list-group-item v-for="(field, index) in fields" :key="index" class="information-item flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between informations-item-title" style="font-size:.5rem">
          <h5 class="mb-2">{{field.label}}</h5>
        </div>
        <div v-if="field.key !== 'PIC'">
          <p class="mb-0 information-item-content" style="font-size: .7rem" v-if="field.key !== 'SIO_NUMBER'">{{ getInfo(field.key) }}</p>
          <p class="mb-0 information-item-content" style="font-size: .7rem" v-else>{{ getSIO(field.key) }}</p>
        </div>
        <div v-else>
          <b-table
            striped
            :items="getPicDetail()"
            :fields="picFields"
          >

          </b-table>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: 'Information',
  props: {
    detailId: {
      type: String,
      required: false // true if api ready
    }
  },
  data() {
    return {
      fields: [
        {key : 'VENDOR_NAME', label : 'Company Name'},
        {key : 'ADDRESS', label : 'Address'},
        {key : 'CITY', label : 'City'},
        {key : 'PROVINCE', label : 'Province'},
        {key : 'POSTAL_CODE', label : 'Postal Code'},
        {key : 'COUNTRY', label : 'Country'},
        {key : 'NAMA_DIREKTUR_UTAMA', label : 'Nama Direktur Utama'},
        {key : 'NOMOR_KONTAK_DIREKTUR_UTAMA', label : 'Nomor Kontak (Contact Number)'},
        {key : 'EMAIL_DIREKTUR_UTAMA', label : 'Email Direktur Utama'},
        {key : 'NAMA_WAKIL_DIREKTUR_UTAMA', label : 'Nama Wakil Direktur Utama'},
        {key : 'NOMOR_KONTAK_WAKIL_DIREKTUR_UTAMA', label : 'Nomor Kontak (Contact Number)'},
        {key : 'EMAIL_WAKIL_DIREKTUR_UTAMA', label : 'Email Wakil Direktur Utama'},
        {key : 'NAMA_KOMISARIS_UTAMA', label : 'Nama Komisaris Utama'},
        {key : 'NOMOR_KONTAK_KOMISARIS_UTAMA', label : 'Nomor Kontak (Contact Number)'},
        {key : 'EMAIL_KOMISARIS_UTAMA', label : 'Email Komisaris Utama'},
        {key : 'NAMA_KOMISARIS', label : 'Nama Komisaris'},
        {key : 'NOMOR_KONTAK_KOMISARIS', label : 'Nomor Kontak (Contact Number)'},
        {key : 'EMAIL_KOMISARIS', label : 'Email Komisaris'},
        {key : 'NAMA_PENANGGUNG_JAWAB_SUPPLIER_USER', label : 'Nama Penanggung Jawab Supplier/User'},
        {key : 'TELEPON_HANDPHONE_USER', label : 'Telephone/Handphone User'},
        {key : 'EMAIL_USER', label : 'Email User'},
        {key : 'WEBSITE_PERUSAHAAN', label : 'Website Perusahaan (Company Website) *Jika ada'},
        {key : 'PIC', label : 'PIC Information'},
        {key : 'NPWP', label : 'NPWP'},
        {key : 'NAMA_BANK', label : 'Nama Bank (Bank Name)'},
        {key : 'NAMA_REKENING', label : 'Nama Rekening (Account Name)'},
        {key : 'NOMOR_REKENING', label : 'Nomor Rekening (Account No.)'},
        {key : 'CURRENCY', label : 'Mata Uang (Currency)'},
        {key : 'HASIL_FINANSIAL_ASSESSMENT', label : 'Hasil Finansial Assessment'},
        {key : 'SIO_NUMBER', label : 'SIO'},
      ],
      picFields : [
        {
          key : 'PIC_NAME',
          label : 'PIC Name',
        },
        {
          key : 'PIC_EMAIL',
          label : 'PIC Email',
        },
        {
          key : 'PIC_PHONE',
          label : 'PIC Phone',
        },
      ],
      picInformations :[
        {
          PIC_NAME : 'PIC 1',
          PIC_EMAIL : 'pic1@mail.com',
          PIC_PHONE : '08288199288928',
        },
        {
          PIC_NAME : 'PIC 2',
          PIC_EMAIL : 'pic2@mail.com',
          PIC_PHONE : '08288199288928',
        },
        {
          PIC_NAME : 'PIC 3',
          PIC_EMAIL : 'pic3@mail.com',
          PIC_PHONE : '08288199288928',
        },
      ]
    }
  },
  methods: {
    getInfo(field){
      const self = this
      if(self.$store.state.datatable.detail){
        if(self.$store.state.datatable.detail[field] !== "" || self.$store.state.datatable.detail[field]){
          return self.$store.state.datatable.detail[field]
        }
        return "-"
      }
      return 
    },
    getSIO(field){
      const self = this
      if(self.$store.state.datatable.detail){
        if(self.$store.state.datatable.detail[field] !== "" && self.$store.state.datatable.detail[field]){
          return 'Yes'
        }
        return 'No'
      }
      return 
    },
    getPicDetail(){
      const self = this
      if(self.$store.state.datatable.detail){
        return self.$store.state.datatable.detail.PIC
      }
    }
  },
}
</script>
